import { render } from "./StatsItem.vue?vue&type=template&id=3e784ce9&ts=true"
import script from "./StatsItem.vue?vue&type=script&lang=ts"
export * from "./StatsItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__